import PropertyTreeNode from '../Node/PropertyTreeNode'

const PropertyTreeEmptyNode = ({ tooltipDisabled, readOnly, ...props }) => {
  return <PropertyTreeNode tooltipDisabled={tooltipDisabled} {...props} />
}
export default PropertyTreeEmptyNode
